import React, { useEffect, useState, useImperativeHandle } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import Button from "components/CustomButtons/CustomButton.js";
import { useTranslation } from "react-i18next";

import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";

const endorsementTypes = [
  { value: "Change Client Name", label: "Change Client Name" },
  { value: "Change Client Address", label: "Change Client Address" },
  {
    value: "Change Client EMail Address",
    label: "Change Client EMail Address",
  },
  { value: "Change Client Phone Number", label: "Change Client Phone Number" },
  {
    value: "Change Client Insurance Company Name",
    label: "Change Client Insurance Company Name",
  },
  {
    value: "Change Client Insurance Policy Number",
    label: "Change Client Insurance Policy Number",
  },
  {
    value: "Change Client Additional Insured",
    label: "Change Client Additional Insured",
  },
  { value: "Change Client State", label: "Change Client State" },
  { value: "Change Client Country", label: "Change Client Country" },
  { value: "Change Client City", label: "Change Client City" },
  { value: "Change Client Zip Code", label: "Change Client Zip Code" },
  {
    value: "Change Client DL License Number",
    label: "Change Client DL License Number",
  },
  { value: "Change Client DL State", label: "Change Client DL State" },
  { value: "Change Client DL Country", label: "Change Client DL Country" },
  { value: "Change Vehicle Year", label: "Change Vehicle Year" },
  { value: "Change Vehicle Make", label: "Change Vehicle Make" },
  { value: "Change Vehicle Model", label: "Change Vehicle Model" },
  { value: "Change Vehicle VIN", label: "Change Vehicle VIN" },
  { value: "Change Vehicle Plate", label: "Change Vehicle Plate" },
  { value: "Change Vehicle Other Make", label: "Change Vehicle Other Make" },
  { value: "Change Vehicle Other Model", label: "Change Vehicle Other Model" },
  { value: "Change Vehicle Other VIN", label: "Change Vehicle Other VIN" },
  { value: "Change Vehicle Other Plate", label: "Change Vehicle Other Plate" },
  { value: "Change Policy Lienholder", label: "Change Policy Lienholder" },
  {
    value: "Change Policy Lienholder Address",
    label: "Change Policy Lienholder Address",
  },
  { value: "Change Policy Start Date", label: "Change Policy Start Date" },
  { value: "Change Policy Start Time", label: "Change Policy Start Time" },
  { value: "Change Policy Time Zone", label: "Change Policy Time Zone" },
];

const useStylesPrincipal = makeStyles(stylePrincipal);

const Step1 = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();

  const classesPrincipal = useStylesPrincipal();

  const { submitAction, previewAction, getCustomer, isLogged } = props;

  useEffect(() => {
    if (props.data) {
      setEndorsementData(props.data.coverages);
    }
  }, [props]);

  const [endorsementData, setEndorsementData] = useState({
    csrinitials: "",
    date_endorsement: "",
    policynumber: props?.data?.coverages?.policy_nbr || "",
    endorsementtype: props?.data?.coverages?.endorsement_type || "",
    policynotes: props?.data?.coverages?.policy_notes || "",
  });

  const [isCompleted, setIsCompleted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newForm = { ...endorsementData, [name]: value };
    setEndorsementData(newForm);
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    const newForm = { ...endorsementData, [name]: value };
    setEndorsementData(newForm);
  };

  const handlePreviewAction = async (event) => {
    previewAction(endorsementData);
  };

  const handleSubmitStep = async (save) => {
    submitAction(endorsementData, save);
  };

  useImperativeHandle(ref, () => ({
    saveStepComplete,
  }));

  const saveStepComplete = (save) => {
    handleSubmitStep(save);
  };

  useEffect(() => {
    validateComplete(endorsementData);
  }, [endorsementData]);
  const validateComplete = (data) => {
    let reqProperties = ["csrinitials", "endorsementtype"];

    let allPropertiesValid = reqProperties.every((prop) => {
      const valueProp =
        typeof data[prop] === "string" ? data[prop].trim() : data[prop];
      return valueProp !== undefined && valueProp !== null && valueProp !== "";
    });
    setIsCompleted(allPropertiesValid);
  };

  return (
    <div>
      <div className={`${classesPrincipal.title} ${classesPrincipal.black}`}>
        {t("endorsement.title")}
      </div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <CustomInput
            labelText="CSR Initials"
            inputProps={{
              name: "csrinitials",
              value: endorsementData.csrinitials,
              onChange: handleInputChange,
              maxLength: 30,
              required: true,
            }}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <CustomInput
            labelText="Date"
            inputProps={{
              name: "date_endorsement",
              value: endorsementData.date_endorsement,
              readOnly: true,
              required: false,
            }}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <CustomInput
            labelText="Policy Number"
            inputProps={{
              name: "policynumber",
              value: endorsementData.policynumber,
              readOnly: true,
            }}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomSelect
            labelText="Endorsement Type"
            menuItems={endorsementTypes}
            inputProps={{
              name: "endorsementtype",
              value: endorsementData.endorsementtype,
              onChange: handleSelectChange,
              required: true,
            }}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Comment"
            inputProps={{
              name: "policynotes",
              value: endorsementData.policynotes,
              onChange: handleInputChange,
              multiline: true,
              rows: 3,
            }}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
      </GridContainer>
      <GridContainer
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ minHeight: "100px", marginTop: "20px" }}
      >
        <GridItem xs={8} />
        <GridItem xs={4}>
          <Button
            id={isLogged ? "continueStep2" : "continueStep2Guest"}
            type="submit"
            onClick={(event) => {
              handleSubmitStep();
            }}
            disabled={!isCompleted}
            variant="green"
            style={{ width: "100%" }}
          >
            {t("common.continue")}
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
});

export default Step1;
